import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link } from 'gatsby';

import ExternalLinkIcon from '~components/common/ExternalLinkIcon';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';
import { HTMLContent } from '../../Content';

export default function VotingRightsRestorationRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  // using this format to populate data to avoid errors when compiling locally
  const felonVoteFees = stateData.felony_laws_restoration_fees
    ? stateData.felony_laws_restoration_fees.html
    : 'N/A';
  const felonVoteRestoration = stateData.felony_laws_restoration_process
    ? stateData.felony_laws_restoration_process.html
    : 'N/A';
  const felonVoteNotes = stateData.felony_voting_options
    ? stateData.felony_voting_options.footnotes
    : 'N/A';
  const felonVoteOfficialUrl = stateData.source_rights_restoration_info
    ? stateData.source_rights_restoration_info.text
    : null;

  return (
    <TableRow key={stateSlug}>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'When are voting rights restored?',
            valueNode: (
              <div>
                <HTMLContent content={felonVoteRestoration} />
              </div>
            ),
          },
          {
            title: 'Financial obligations',
            valueNode: (
              <div>
                <HTMLContent content={felonVoteFees} />
              </div>
            ),
          },
          {
            title: 'Notes',
            valueNode: (
              <div>
                <HTMLContent content={felonVoteNotes} />
              </div>
            ),
          },
          {
            title: 'Learn more',
            valueNode: (
              <div>
                {felonVoteOfficialUrl ? (
                  <Link
                    to={felonVoteOfficialUrl}
                    target='_blank'
                    rel='noopener'
                    title={`${stateName} restoration information`}
                  >
                    {stateName} restoration information
                    <ExternalLinkIcon />
                  </Link>
                ) : (
                  ''
                )}
              </div>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

VotingRightsRestorationRowRenderer.propTypes = rowRendererProps;
